import React, { useContext, useState } from "react"
import Header from "../../../../components/header/header"
import { StateContext } from "../../../../context/StateContext"
import RemoteButton from "./RemoteButton"
import LastButton from "./LastButton"
import Loading from "../../../../components/loading/loading"

/**
 * Радиопульт.
 */
const Remote = () => {
    const STATE = useContext(StateContext)

    const [buttons, setButtons] = useState(STATE.lastData.remote.buttons)
    const [lastButton, setLastButton] = useState(STATE.lastData.remote.lastButton)

    const changeButtonMelody = (melody, index) => {
        const newButtons = [...buttons]
        newButtons[index] = melody

        setButtons(newButtons)
    }

    const changeLastButtonMelody = (melody) => {
        setLastButton(melody)
    }

    const saveRemote = () => {
        const remote = {
            buttons,
            lastButton
        }

        STATE.sendData({ remote })
    }

    const buttonsList = buttons
        .filter((_, index) => {
            return index < (STATE.lastData.maxMelodies - 1)
        })
        .map((melody, index) => {
            return (
                <RemoteButton
                    index={index}
                    melody={melody}
                    key={index}
                    setMelody={changeButtonMelody}
                />
            )
        })

    if (STATE.lastData.maxMelodies === 0) {
        return (
            <div className="main-area-field full-height">
                <div className="main-area full-height">
                    <div className="page-area no-p">
                        <Header
                            title={"Радиопульт"}
                            backTitle="Настройки"
                            backUrl={`/device/${STATE.subscribed.id}/settings`}
                        />

                        <div className="page-area center-h">
                            <div className="content">
                                <div className="block trans-block">
                                    <div
                                        style={{ textAlign: 'center' }}
                                        className="template-title"
                                    >
                                        ЗВОНЫ ОТСУТСТВУЮТ
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="main-area-field full-height">
            <div className="main-area full-height">
                <div className="page-area no-p">
                    <Header
                        title={"Радиопульт"}
                        backTitle="Настройки"
                        backUrl={`/device/${STATE.subscribed.id}/settings`}
                    />

                    <div className="page-area center-h">
                        <div className="content">
                            <div className="block trans-block">
                                <div className="melodies-settings">
                                    {STATE.lastData.maxMelodies > 0 && buttonsList}

                                    {STATE.lastData.maxMelodies > 14 && (
                                        <LastButton
                                            melody={lastButton}
                                            setMelody={changeLastButtonMelody}
                                        />
                                    )}

                                    {STATE.lastData.maxMelodies > 0 && (
                                        <button
                                            onClick={saveRemote}
                                            style={{ marginTop: '1rem' }}
                                            type="button"
                                            className="template-setting__save"
                                        >
                                            {!STATE.isSending && "Сохранить"}
                                            {STATE.isSending && <Loading />}
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Remote